import editDocumentFormActions from './actionCreators/editDocumentForm';
import editJournalFormActions from './actionCreators/editJournalForm';
import editResumeFormActions from './actionCreators/editResumeForm';
import editCoverLetterFormActions from './actionCreators/editCoverLetterForm';
import userInfoActions from './actionCreators/userInfo';
import storeUserProfile from './actionCreators/storeUserProfile';
import {
  highLightSuperscript,
  highLightSubscript,
  clearXscriptHighLight,
  onlyHighLightSubscript,
  onlyHighLightSuperscript,
} from './actionCreators/xScriptHighlight';
import websocketActions from './actionCreators/websocket';
import notificationActions from './actionCreators/notifications';
import redirectNodeActions from './actionCreators/redirectNode';
import referenceModalActions from './actionCreators/referenceModal';
import commentActions from './actionCreators/comments';
import mostUsedToolsetActions from './actionCreators/mostUsedToolset';
import listingsActions from './actionCreators/listings';
import applicationActions from './actionCreators/application';
import commonActions from './actionCreators/common';
import organizationActions from './actionCreators/organization';
import userApplicationActions from './actionCreators/userApplications';
import fileFolderInfo from './actionCreators/fileFolderInfo';
import tetraActions from './actionCreators/tetra';
import applicationFormActions from './actionCreators/applicationForm';
import shareItemsActions from './actionCreators/shareItems';
import expertTipsActions from './actionCreators/expertTips';
import linkedInOptimizerActions from './actionCreators/linkedInOptimizer';
import contentGenerationAction from './actionCreators/contentGeneration';
import careerPathAction from './actionCreators/careerPath';
import questionGeneratorAction from './actionCreators/questionGenerator';
import interviewFileAction from './actionCreators/interviewFile';
import interviewReview from './actionCreators/interviewReview';
import careerFinancialsAction from './actionCreators/careerFinancials';

const Actions = {
  editDocumentFormActions,
  editJournalFormActions,
  editResumeFormActions,
  editCoverLetterFormActions,
  userInfoActions,
  storeUserProfile,
  highLightSuperscript,
  highLightSubscript,
  onlyHighLightSuperscript,
  onlyHighLightSubscript,
  clearXscriptHighLight,
  websocketActions,
  notificationActions,
  redirectNodeActions,
  referenceModalActions,
  commentActions,
  mostUsedToolsetActions,
  fileFolderInfo,
  tetraActions,
  listingsActions,
  commonActions,
  organizationActions,
  applicationActions,
  userApplicationActions,
  applicationFormActions,
  shareItemsActions,
  expertTipsActions,
  linkedInOptimizerActions,
  contentGenerationAction,
  careerPathAction,
  questionGeneratorAction,
  interviewFileAction,
  interviewReview,
  careerFinancialsAction,
};
export default Actions;
